import { useAuthUserStore } from "@/stores/authUser";

export default function guest() {
    const authUserStore = useAuthUserStore();
    if (authUserStore.check) {
        return {
            name: "launch"
        };
    }
}
